import { useIntl } from 'react-intl';

type RelativeTimeUnit = 'day' | 'hour' | 'minute' | 'second';

function getRelativeTimeParts(isoDate: string): {
  unit: RelativeTimeUnit;
  value: number;
} {
  const diff = Date.now() - new Date(isoDate).getTime();
  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return { unit: 'second', value: -seconds };
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return { unit: 'minute', value: -minutes };
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return { unit: 'hour', value: -hours };
  return { unit: 'day', value: -Math.floor(hours / 24) };
}

export function useTimeAgo() {
  const intl = useIntl();
  return (isoDate: string): string => {
    const { unit, value } = getRelativeTimeParts(isoDate);
    return intl.formatRelativeTime(value, unit, { numeric: 'auto' });
  };
}
